import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=668a4b58&scoped=true"
import script from "./MaterialDetail.vue?vue&type=script&lang=js"
export * from "./MaterialDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a4b58",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreMaterial/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreMaterial%2FMaterial%2FMaterialDetail.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports